import { render, staticRenderFns } from "./unLoaded copy.vue?vue&type=template&id=2570ede6&scoped=true"
import script from "./unLoaded copy.vue?vue&type=script&lang=js"
export * from "./unLoaded copy.vue?vue&type=script&lang=js"
import style0 from "./unLoaded copy.vue?vue&type=style&index=0&id=2570ede6&prod&scoped=true&lang=scss"
import style1 from "./unLoaded copy.vue?vue&type=style&index=1&id=2570ede6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2570ede6",
  null
  
)

export default component.exports